import React, { useState } from 'react';
import Sidebar from '../../components/Sidebar';
import { Outlet } from "react-router-dom";
import Header from '../../components/Header';
import PageContainer from '../../components/PageContainer';

const Reports = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

   return (
      <div className="h-screen w-full flex overflow-hidden bg-white">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onMenuClick={() => setSidebarOpen((s) => !s)} />

        <PageContainer>
          <Outlet />
        </PageContainer>
      </div>
    </div>
  );
};



export default Reports;
